<template>
  <div>
    <breadcrumb/>
    <BirthdayList />
  </div>
</template>

<script>
import BirthdayList from "@/components/Birthdays/BirthdayList";
import Breadcrumb from "@/components/General/Breadcrumb";
export default {
  components: {
    BirthdayList,
    Breadcrumb
  },
};
</script>